// src/locales/en/procurement.js
// Shared namespace for the Payables / Supplier Statement pages (mirrors how Receivables /
// Customer Statement strings live inside offlineSales.js).
export const procurement = {
  // Payables page
  payables: 'Payables',
  payablesDescription: 'Outstanding supplier balances from purchase orders',
  totalOutstanding: 'Total Outstanding',
  supplier: 'Supplier',
  phone: 'Phone',
  aging0to30: '0-30 days',
  aging31to60: '31-60 days',
  aging61to90: '61-90 days',
  aging90plus: '90+ days',
  noPayablesFound: 'No outstanding payables',
  noPayablesFoundDescription: 'All supplier balances are settled',
  failedToLoadPayables: 'Failed to load payables',
  searchBySupplierName: 'Search by supplier name or phone',
  supplierStatement: 'Supplier Statement',

  // Supplier Statement page
  openingBalance: 'Opening Balance',
  closingBalance: 'Closing Balance',
  debit: 'Debit',
  credit: 'Credit',
  date: 'Date',
  type: 'Type',
  reference: 'Reference',
  balance: 'Balance',
  selectDateRange: 'Select date range',
  noTransactionsFound: 'No transactions found',
  noTransactionsFoundDescription: 'No transactions in the selected date range',
  failedToLoadSupplierStatement: 'Failed to load supplier statement',

  // Transaction type labels — used via t(`procurement.transactionType_${tx.type}`)
  transactionType_purchase_order: 'Purchase Order',
  transactionType_supplier_payment: 'Payment',
  transactionType_debit_note: 'Debit Note',

  // Supplier statement print
  supplierStatementTitle: "SUPPLIER STATEMENT",
  thankYouMessage: "Thank you for your business!",
  accountStart: "Account start",
  today: "Today",
  statementPeriod: "Period",
  statementOrderHint: "Oldest first — running balance reads top to bottom",
};
